module.exports = __webpack_public_path__ + "assets/img/logo.dca6ec09.png";